<table mat-table [dataSource]="systems">
  <ng-container matColumnDef="id">
    <td mat-cell *matCellDef="let system">
      <a
        mat-button
        color="primary"
        title="Open system"
        [routerLink]="['/systems', system.id]"
        target="_blank"
      >
        {{ system.id }}
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="manufacturers">
    <td mat-cell *matCellDef="let system" class="align-right">
      @for (manufacturer of system.manufacturers; track manufacturer) {
      <div class="spaced-list-element">
        {{ manufacturer.name }}
      </div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="thumbnail">
    <td mat-cell *matCellDef="let system" class="align-right">
      <div
        class="thumbnail-wrapper"
        appTooltip
        [tooltipContent]="thumbnailMagnifier"
        tooltipPlacement="bottom"
      >
        @if (system.thumbnail.schematic) {
        <img
          mat-card-lg-image
          src="{{ system.thumbnail.schematic.url }}"
          alt="thumbnail"
          class="thumbnail"
        />
        }
      </div>

      <div #thumbnailMagnifier>
        @if (system.thumbnail.schematic) {
        <img
          mat-card-lg-image
          src="{{ system.thumbnail.schematic.url }}"
          alt="System image"
          class="thumbnail-magnifier"
        />
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="modelName">
    <td mat-cell *matCellDef="let system" class="align-right">
      {{ system.modelName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="interfaces">
    <td mat-cell *matCellDef="let system" class="align-right">
      @for ( interfaceConfiguration of system.interfaceConfigurations; track
      interfaceConfiguration ) {
      <app-interface
        [interfaceConfiguration]="interfaceConfiguration"
      ></app-interface>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <td mat-cell *matCellDef="let system">
      <a
        mat-icon-button
        title="Open system"
        [routerLink]="['/systems', system.id]"
        target="_blank"
      >
        <mat-icon>search</mat-icon>
      </a>
      <a
        mat-icon-button
        title="Open in HVAC Tool"
        href="{{ getSystemUrl(system) }}"
        target="_blank"
      >
        <mat-icon>open_in_new</mat-icon>
      </a>
    </td>
  </ng-container>

  <tr mat-row *matRowDef="let whydoesthiswork; columns: columnsToDisplay"></tr>
</table>
